import { render, staticRenderFns } from "./DocumentCard.vue?vue&type=template&id=1db0396a&scoped=true&"
import script from "./DocumentCard.vue?vue&type=script&lang=js&"
export * from "./DocumentCard.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCard.vue?vue&type=style&index=0&id=1db0396a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db0396a",
  null
  
)

export default component.exports